<template lang="">
  <div>
    <v-select
      :value="paymentMethod"
      :options="paymentMethodOptions"
      :clearable="false"
      :disabled="disabled"
      :placeholder="placeholder ?? $t('placeholderSelect')"
      :reduce="(val) => val"
      @input="(val) => $emit('update:paymentMethod', val)"
    >
      <template #option="{ label }">
        {{ $t(`packageConfig.${label}`) }}
      </template>

      <template #selected-option="{ label }">
        {{ $t(`packageConfig.${label}`) }}
      </template>
      <template #no-options>
        {{ $t('noOptions') }}
      </template>
    </v-select>
  </div>
</template>

<script>

export default {
  components: {
    vSelect: () => import('vue-select'),
  },
  props: {
    paymentMethod: {
      type: [String, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    paymentMethodOptions: {
      type: Array,
      default: () => ['CREDIT', 'MONEY'],
    },
  },
}
</script>
<style lang=""></style>
